<template>
<div>
    <span :class="className">
        {{scoreText}}
    </span>
</div>
</template>

<style lang="scss" scoped>

</style>

<script>
import {
    getScoreColor
} from "../../../config/mUtils.js"
export default {
    props: {
        data: {},
        columnData: {},
        status: {},
        editLocation: {}
    },
    data() {
        return {
            score: 0,
            scoreText: "",
            className:""
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
           this.score = this.data.Score;
           this.scoreText = this.data.ScoreText;
           if ( typeof this.score != "undefined" && this.score != null){
                this.className = getScoreColor(this.score);
           }else{
               this.className = "cs-color-frenchgrey";
           }
        },
    },
    watch: {
        editLocation: function () {},
        data: function () {
            this.init();
        },
        status: function () {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkScoreCell.vue